<template>
    <div ref="textReadingViewWrapper" class="textReading-view">
        <!-- <div class="articleimagesbox" v-show="isshowswiper">
            <div class="close" @click="isshowswiper=false">X</div>
            <swiper :options="swiperOption" ref="imagesboxref">
                  <swiper-slide v-for="i in articleData.ImgList" :key="i" >
                    <div class="imgbox">
                       <img :src="i.ImgUrl?i.ImgUrl:i.ImgFileName"/>
                    </div>
                  </swiper-slide>
                  <button class="swiper-button-prev" slot="button-prev" @click="swiperprev"></button>
                  <button class="swiper-button-next" slot="button-next" @click="swipernext"></button>
            </swiper> 
        </div> -->
        <articleImagesBox :articleData="articleData" v-if="isshowswiper" @closearticleimagesbox="closearticleimagesbox"/>
        <div class="textReading-body-wrapper">
            <div class="textReading-body" v-if="articleData">
                <div class="recomm-article-mask-box" :style="{margin:!hasresouce?'auto':'initial'}">
                    <div class="body-main-mask" >
                        <div class="article-mask">
                            <h5 class="article-title" v-html="articleData.Title">
                               
                            </h5>
                            <div v-show="baseInfo && articleData.Content" class="base-infos">
                                <span><canvas id="myCanvas" width="500" height="20"/></span>
                                <div>
                                    <button @click="openPrint">打印当页正文</button>
                                    <div v-if="isNexus.includes('articlecollection')"
                                        v-show="baseInfo.Year"
                                        @click="collectionBtnClick">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            width="14px"
                                            height="14px"
                                            viewBox="0 0 14 14"
                                            version="1.1">
                                            <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
                                            <title>收藏</title>
                                            <desc>Created with Sketch.</desc>
                                            <g id="页面-1"
                                            stroke="none"
                                            stroke-width="1"
                                            fill="none"
                                            fill-rule="evenodd">
                                                <g id="我的收藏"
                                                :fill="collectionId === 0 || collectionId === undefined ? '#ccc': themeColor"
                                                transform="translate(-1242.000000, -318.000000)">
                                                    <g id="hot" transform="translate(440.000000, 140.000000)">
                                                        <g id="item1" transform="translate(34.000000, 82.000000)">
                                                            <g id="收藏" transform="translate(768.000000, 96.000000)">
                                                                <path d="M11.1284106,13.9998229 C11.077377,
                                                                13.9998229 11.0263434,13.9871667 10.9796347,
                                                                13.9613856 L6.99987786,11.7648387 L3.02055353,
                                                                13.9613856 C2.91329644,14.0209165 2.78182002,
                                                                14.0110728 2.6832127,13.9356046 C2.58460538,
                                                                13.8606051 2.53530173,13.733106 2.55606116,
                                                                13.6070131 L3.315943,8.95376479 L0.0969330106,
                                                                5.65847561 C0.00957038132,5.56894499 -0.0220012605,
                                                                5.43535219 0.0156252209,5.3139468 C0.0536841836,
                                                                5.19207265 0.153588961,5.10347953 0.274253183,
                                                                5.08472967 L4.72325974,4.40598447 L6.71270567,
                                                                0.172264412 C6.82039524,-0.0574214707 7.17979297,
                                                                -0.0574214707 7.28705005,0.172264412 L9.27692846,
                                                                4.40598447 L13.725935,5.08472967 C13.8465992,
                                                                5.10347953 13.946504,5.19207265 13.984563,
                                                                5.3139468 C14.021757,5.43535219 13.9906178,
                                                                5.56894499 13.9032552,5.65847561 L10.6838127,
                                                                8.95376479 L11.4441271,13.6070131 C11.4648865,
                                                                13.733106 11.4151503,13.8606051 11.3169755,
                                                                13.9356046 C11.2611845,13.9782605 11.1950138,
                                                                13.9998229 11.1284106,13.9998229 Z"/>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div v-if="articleData.ImgList">
                                <div class="imglist" v-if="(articleData.ImgList.length>0 && articleData.Content.indexOf('/qkimages')==-1) || (!userisauthorized && articleData.ImgList.length>0)" @click="isshowswiper=true">
                                    <div>
                                        <img :src="articleData.ImgList[0].ImgUrl"/>
                                    </div>
                                    <div :style="{color:themeColor}"> {{ langTransfer('打开文本图片集') }}</div>
                                </div>
                            </div>
                            <div class="article-content-bindDom" v-html="articleData.Content"/>
                            <div class="showreadall" v-if="!userisauthorized && !isPending" @click="$store.commit('setShowLoginRegister', true)" :style="{color:themeColor}"> {{ langTransfer('阅读全文') }}</div>
                            <div v-show="isPending"
                                 class="loader">
                                <svg id="Layer_1"
                                     version="1.1"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     x="0px"
                                     y="0px"
                                     width="48px"
                                     height="60px"
                                     viewBox="0 0 24 30"
                                     style="enable-background:new 0 0 50 50;"
                                     xml:space="preserve">
                                    <rect :fill="themeColor"
                                          x="0"
                                          y="10"
                                          width="4"
                                          height="10"
                                          opacity="0.2">
                                        <animate attributeName="opacity"
                                                 attributeType="XML"
                                                 values="0.2; 1; .2"
                                                 begin="0s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="height"
                                                 attributeType="XML"
                                                 values="10; 20; 10"
                                                 begin="0s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="y"
                                                 attributeType="XML"
                                                 values="10; 5; 10"
                                                 begin="0s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                    </rect>
                                    <rect :fill="themeColor"
                                          x="8"
                                          y="10"
                                          width="4"
                                          height="10"
                                          opacity="0.2">
                                        <animate attributeName="opacity"
                                                 attributeType="XML"
                                                 values="0.2; 1; .2"
                                                 begin="0.15s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="height"
                                                 attributeType="XML"
                                                 values="10; 20; 10"
                                                 begin="0.15s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="y"
                                                 attributeType="XML"
                                                 values="10; 5; 10"
                                                 begin="0.15s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                    </rect>
                                    <rect :fill="themeColor"
                                          x="16"
                                          y="10"
                                          width="4"
                                          height="10"
                                          opacity="0.2">
                                        <animate attributeName="opacity"
                                                 attributeType="XML"
                                                 values="0.2; 1; .2"
                                                 begin="0.3s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="height"
                                                 attributeType="XML"
                                                 values="10; 20; 10"
                                                 begin="0.3s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                        <animate attributeName="y"
                                                 attributeType="XML"
                                                 values="10; 5; 10"
                                                 begin="0.3s"
                                                 dur="0.6s"
                                                 repeatCount="indefinite" />
                                    </rect>
                                </svg>
                            </div>
                        </div>
                        <!-- <div class="third-platform-shares">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                            <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                        </div> -->

                    </div>
                    <div class="recomm-article-mask" v-if="relevantArticleList.length>0">
                        <div class="catelog-header">
                            <i :style="{background: themeColor}" class="warning-icon"/>
                            <h5>
                                {{ langTransfer('相关文章') }}
                            </h5>
                        </div>
                        <div class="recomm-catelog-body">
                            <div class="recomm-catelog-item"
                                  v-for="(item,index) in relevantArticleList" @click="goTextReading(item)">
                                <h5 @mouseenter="recommhover = index"
                                @mouseleave="recommhover = -1" :style="{color: recommhover === index ? themeColor : ''}">{{$tools.removeHtml(item.Title)}}</h5>
                                <p>{{$tools.removeHtml(item.MagazineName)}} {{item.Year}}年{{item.Issue}}期</p>
                                <p class="summary">{{$tools.removeHtml(item.Summary)}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="qrcode-catelog-mask" v-show="hasresouce">
                    <div class="info-qcode-mask">
                         <img :src="baseInfo.__cover"  class="cover"  v-if="resourceType === 'magazine' && baseInfo.CoverImages" :src2="baseInfo.CoverImages[2]" @error="$tools.nocover">
                        <img :src="baseInfo.__cover"
                             class="cover" v-else>
                        <h5>{{ baseInfo.Name }}</h5>
                        <span>{{ baseInfo.__midInfo }}</span>
                        <template v-show="baseInfo.ShortCode">
                            <div ref="qrcode"
                                 class="qrcode">
                                 <img ref="qrcodeimag">
                            </div>
                        </template>
                    </div>
                    <div :style="{transform: `translateY( ${catelogMaskPosY}px )`}"
                         class="catelog-mask">
                        <h5>{{ langTransfer(catelogHeaderText) }}</h5>
                        <div ref="catelogBodyWrapper"
                             :style="{maxHeight: `${catelogListHeight}px`}"
                             class="catelog-body-wrapper">
                            <div class="catelog-body">
                                <div v-for="(cate,index) in catelogList"
                                     :key="index"
                                     class="catelog-item"
                                     @click="readOther(cate)" :style="{color: articleData.ArticleID === cate.ArticleID ? themeColor : ''}">
                                    {{ cate.Title.replace(/<\/?.+?>/g,"") }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;height: 20px;"/>
                <div class="site-footer">
                    <Footer/>
                </div>
            </div>
        </div>
        <backBtn/>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import backBtn from '@/components/backBtn'
    import Footer from '@/components/footer'
    import articleImagesBox from '@/components/articleImagesBox'
    export default {
        components: {
            backBtn,Footer,articleImagesBox
        },
        data () {
            return {
                textReadingBScroll: null,
                catelogBodyBScroll: null,
                catelogMaskPosY: 0,
                articleData: {},
                baseInfo: {},
                catelogList: [],
                viewHeight: 0,
                lastParams: {},
                collectionId: undefined,
                isPending: false,
               
                hasresouce:true,
                userisauthorized:false,
                isshowswiper:false,
                resourceType:'',
                recommhover:-1,
                relevantArticleList:[],
                searchfilterkeyword:window.SearchFilterKeyword,
                searchsavekeyword:window.SearchSaveKeyword
            }
        },
        computed: {
            catelogListHeight () {
                const { viewHeight } = this
                return viewHeight - 300
                //return 300;
            },
            catelogHeaderText () {
                const { baseInfo } = this
                if (baseInfo.Year !== undefined) {
                    return '期刊目录'
                }

                if (baseInfo.PublishName !== undefined) {
                    return '图书目录'
                }
                if (baseInfo.PubDate !== undefined) {
                    return '报纸目录'
                }
                return '目录'
            },
            articleAuthor () {
                const { articleData, baseInfo } = this
                if (baseInfo.Year !== undefined) {
                    return articleData.Author ? `作者：${ articleData.Author }` : '作者：佚名'
                }

                if (baseInfo.PublishName !== undefined) {
                    return baseInfo.Author ? `作者：${ baseInfo.Author }` : '作者：佚名'
                }
                if(articleData.Author)
                {
                    return articleData.Author ? `作者：${ articleData.Author }` : '作者：佚名'
                }
                return '作者：佚名'
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            isNexus () {
                return this.$store.state.isNexus
            }
        },
        activated () {
            this.setViewHeight()
        },
        mounted () {
            this.initBScroll()
            this.watchWinodwResize()
        },
        methods: {
            openPrint()
            {
                const { id, year, issue,resourceType,articleId,token } = this.$route.params
                const params = {
                    resourceType,
                    id,
                    year,
                    issue,
                    articleId,
                    token
                }
                let routeUrl = this.$router.resolve({
                    name: 'textPrint',
                    params:params
                 });
                 window.open(routeUrl .href, '_blank');
            },
            closearticleimagesbox()
            {
                this.isshowswiper = false;
            },
            openswiperimg(u)
            {
                window.open(u)
            },
            initBScroll () {
                this.$nextTick(() => {
                    /*this.textReadingBScroll = new BScroll(this.$refs.textReadingViewWrapper, {
                        bounce: false,
                        click: true,
                        tap: true,
                        momentum: false,
                        probeType: 3,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 0
                        },
                        scrollbar: {
                            fade: false,
                            interactive: true // 1.8.0 新增
                        },
                        preventDefault: false
                    })
                    this.textReadingBScroll.on('scroll', (pos) => {
                        if (pos.y <= -672) {
                            this.catelogMaskPosY = -(pos.y + 672)
                        } else {
                            this.catelogMaskPosY = 0
                        }
                    })
                    this.catelogBodyBScroll = new BScroll(this.$refs.catelogBodyWrapper, {
                        bounce: false,
                        click: true,
                        momentum: false,
                        stopPropagation: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 0
                        }
                    })*/
                })
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 132,
                    height: 132,
                    text
                })
            },
            async getShortQCUrl (shortCode) {
                try {
                    let {Data} = await this.$apis('user').getuserisauthorized();
                    this.userisauthorized = Data;
                    if (!Data) {
                        this.$refs.qrcodeimag.src=require('@/assets/defaultqrcode.png');
                        this.$refs.qrcode.className="qrcode qrocdenologin"
                        return;
                    }


                    const data = await this.$apis('shortQC').getShortQCUrl(shortCode)
                    if (data) {
                        this.initQrCode(data)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getNewspaperQrUrl(id,year)
            {
                try {   
                    const data = await this.$apis('shortQC').getNewspaperQrUrl(id,year)          
                    this.initQrCode(data)
                } catch (error) {
                    console.log(error)
                }
            },
            async getRelevantArticleList(_title,_titleid)
            {
                 if(this.resourceType=='magazine')
                {
                    let splitwordsdata =  await this.$apis('magazine').getRelevantKeyWords(_title);

                    let tempsplitwordsdatastr = '';
                    if(splitwordsdata){
                        tempsplitwordsdatastr = splitwordsdata.join();
                    }
                    

                    for (let i = 0; i < this.searchfilterkeyword.length; i++) {
                        tempsplitwordsdatastr = tempsplitwordsdatastr.replaceAll(this.searchfilterkeyword[i],'');
                    }

                    let tempsplitwordsdatastrarr = tempsplitwordsdatastr.split(',');

                    let splitwords = [];
                    for (let i = 0; i < tempsplitwordsdatastrarr.length; i++) {
                        if(tempsplitwordsdatastrarr[i].length>1){
                            splitwords.push(tempsplitwordsdatastrarr[i]);
                        }else{
                            if(this.searchsavekeyword.indexOf(tempsplitwordsdatastrarr[i])!=-1)
                            {
                                splitwords.push(tempsplitwordsdatastrarr[i]);
                            }
                        }       
                    }   


                    let _relevantdata =  await this.$apis('magazine').getRelevantArticleList(splitwords.slice(0,3).join(' '),1,6);
                    
                    if(_relevantdata.Data)
                    {
                        let outputdata = [];
                        for (let i = 0; i <_relevantdata.Data.length ; i++) {
                            if(_relevantdata.Data[i].ArticleID!=_titleid){
                                outputdata.push(_relevantdata.Data[i])
                            }
                        }
                        this.relevantArticleList = outputdata.slice(0.5);
                    }
                }
            },
            async getArticle (params) {
                window.scrollTo({ 
                    top: 0, 
                    behavior: "smooth" 
                });
                let d  = {};
                this.isPending = true;
                const { resourceType, id, articleId,year,issue,token} = params;
                this.resourceType = resourceType;

                if(token.toLowerCase()!='token'){
                    d = await this.$apis(resourceType).getArticle(articleId,token);
                }else{
                    d = await this.$apis(resourceType).getArticle(articleId,id,year,issue);
                }
                this.articleData = d.Data;
                if(resourceType=='magazine'){
                    this.getRelevantArticleList(d.Data.Title,d.Data.ArticleID);
                }
                
                if (d.Code === 4) {
                    let loginurldata = await this.$apis('user').getloginurl();
                    this.$store.commit('setUserLoginUrl',loginurldata.Data);
                    //this.$store.commit('setShowLoginRegister', true)
                    
                }
                if(d.Code==1){
                    this.userisauthorized = true;
                }
                this.$tools.checkBindMobile(d.Code);
                debugger
                this.isPending = false;
                //console.log(error)

                (()=>{
                    if(d.Data && d.Data.Author){
                        if(document.getElementById('myCanvas')){
                            this.$tools.initAuthorCanvas(d.Data.Author)
                        }else{
                            let myCanvastimer =setInterval(function()
                            {
                                if(document.getElementById('myCanvas')){
                                    this.$tools.initAuthorCanvas(d.Data.Author)
                                    clearInterval(myCanvastimer);
                                }
                            },1000);
                        }                           
                    } 
                })();
            },
            async getDetailInfo (params) {
                try {
                    const {
                        resourceType, id, year, issue
                    } = params
                    let { Data } = await this.$apis(resourceType).getDetailInfo(id, year, issue);
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`;
                    [Data] = this.$tools[toolFnName]([Data], '-l')
                    this.baseInfo = Data
                    this.$nextTick(() => {
                        // if(resourceType==='newspaper')
                        //     this.getNewspaperQrUrl(id,year);
                        // else
                            this.getShortQCUrl(Data.ShortCode)
                    })
                } catch (error) {
                    this.hasresouce = false;
                    console.log(error)
                }
            },
            goTextReading (item) {
                const params = {
                    resourceType:'magazine',
                    id:item.MagazineGuid,
                    year:item.Year,
                    issue:item.Issue,
                    articleId: item.ArticleID,
                    token:item.Token
                }
                this.$router.push({
                    name: 'textReading',
                    params
                })
            },
            async getDetailCatelog (params) {
                try {
                    const {
                        resourceType, id, year, issue
                    } = params
                    const { Data } = await this.$apis(resourceType).getCatelog(id, year, issue)
                    if (!Data) {
                        this.catelogList = []
                        return
                    }
                    if (resourceType === 'magazine' || resourceType === 'newspaper') {
                        Data.forEach((e) => {
                            if (e.Articles.length > 0) {
                                e.Articles.forEach((child) => {
                                    this.catelogList.push(child)
                                })
                            } else {
                                if (resourceType === 'magazine'){
                                    this.catelogList.push(e)
                                }
                            }
                        })
                    } else {
                        this.catelogList = Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            setViewHeight () {
                const viewHeight = document.documentElement.clientHeight || document.body.clientHeight
                this.viewHeight = viewHeight
            },
            watchWinodwResize () {
                const vm = this
                window.addEventListener('resize', () => {
                    vm.setViewHeight()
                })
            },
            readOther (item) {
                const { name, params } = this.$route
                params.articleId = item.ArticleID
                if (this.textReadingBScroll) {
                    this.textReadingBScroll.refresh()
                    this.textReadingBScroll.scrollTo(0, 0)
                }
                this.$router.push({
                    name,
                    params
                })
            },
            collectionBtnClick () {
                let userInfos
                try {
                    userInfos = this.$cookies.get('user')
                } catch (error) {
                    console.log(error)
                }
                if (!userInfos) {
                    this.$store.commit('setShowLoginRegister', true)
                    return
                }
                const { collectionId } = this
                if (collectionId !== 0) {
                    this.removeFromCollection()
                } else {
                    this.addToCollection()
                }
            },
            async addToCollection () {
                try {
                    this.collectionId = undefined
                    const {
                        articleId, resourceType
                    } = this.$route.params
                    const formData = {
                        resourcekind: resourceType === 'magazine' ? 101 : 102,
                        resourceid: articleId
                    }
                    const data = await this.$apis('user').addToBookCase(formData)
                    if (data.Code === 1) {
                        this.collectionId = data.Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async removeFromCollection () {
                try {
                    this.collectionId = undefined
                    const {
                        articleId, resourceType
                    } = this.$route.params
                    const formData = {
                        resourcekind: resourceType === 'magazine' ? 101 : 102,
                        resourceid: articleId
                    }
                    const data = await this.$apis('user').removeFromCollection(formData)
                    if (data.Code === 1) {
                        this.collectionId = 0
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async isInUserCollection (params) {
                try {
                    const { userInfos } = this.$store.state
                    if (!userInfos) {
                        return
                    }
                    const {
                        articleId
                    } = params
                    const { Data } = await this.$apis('user').isInUserCollection(articleId)
                    this.collectionId = Data
                } catch (error) {
                    console.log(error)
                }
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { params } = to
            this.articleData = {}
            this.hasresouce = true;
            this.lastParams = params
            this.baseInfo = {}
            this.catelogList = []
            this.collectionId = undefined
            this.isInUserCollection(params)
            this.getArticle(params)
            this.getDetailInfo(params)
            this.getDetailCatelog(params)
            next();
        },
        beforeRouteEnter (to, from, next) {

            next((vm) => {

                const { params } = vm.$route
                /*if (vm.$tools.isSameParams(params, vm.lastParams) && vm.articleData.Content) {
                    return
                }*/
                vm.hasresouce = true;
                vm.lastParams = params
                vm.articleData = {}
                vm.baseInfo = {}
                vm.catelogList = []
                vm.collectionId = undefined
                vm.getArticle(params)
                vm.getDetailCatelog(params)
                vm.getDetailInfo(params)
                vm.isInUserCollection(params)
            })
        }
    }
</script>

<style lang="scss" scoped>

    .textReading-view {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
        //overflow: hidden;
    }

    .textReading-body-wrapper {
        width: 100%;
        padding-top: 66px;
        margin: 0 auto;
    }

    .textReading-body-wrapper::before {
        content: "";
        height: 600px;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        //background-image: url("../../assets/textReadingBG.png");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .textReading-body {
        position: relative;
        width: 1140px;
        margin: 0 auto;
        padding-bottom: 138px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .body-main-mask {
        width: 850px;
        box-sizing: border-box;
        padding: 30px 74px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .recomm-article-mask-box{
        width: 850px;
    }
    .recomm-article-mask {
        margin-top: 30px;
        width: 850px;
        box-sizing: border-box;
        //padding: 30px 74px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        .catelog-header {
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #F0F2F7;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 50px;
            }

            .warning-icon {
                display: block;
                width: 4px;
                height: 16px;
                margin-right: 8px;
                background: #0084FF;
                border-radius: 2px;
            }
        }
        .recomm-catelog-body{
            width: 100%;
            box-sizing: border-box;
            padding: 27px;
            .recomm-catelog-item{
                h5{
                    font-size: 18px;
                    margin: 20px 0;
                    cursor:pointer;
                }
                p{
                    font-size: 14px;
                    margin-bottom: 10px;
                    color: #000000;
                }    
                p.summary{
                    height: 41px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    color: #c3c3c3;
                    -webkit-box-orient: vertical;
                }            
            }
            .recomm-catelog-item:not(:last-child){

                border-bottom: 1px solid #e9e9e9;
            }
        }
    }

    .article-mask {
        width: 100%;

        h5 {
            max-height: 100px;
            min-height: 50px;
            
            font-size: 36px;
            color: #1A1A1A;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
        }

        .base-infos {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0 20px;
            height: 22px;

            span {
                
                font-size: 16px;
                color: #ABADB1;
            }
            &>div{
                display: flex; 

                button{
                    margin-right: 10px;
                }
                .imagesbox{
                    width: 70px;
                    line-height: 16px;
                }
                div {
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                }
            }

        }
        .imglist{
            width: 200px;
            float: left;
            text-align: center;
            margin-right: 30px;
            border: 1px solid #c7c7c7;
            cursor: pointer;
            &>div{
                font-size: 14px;
                &>img{
                    width: 200px;
                    height: 200px;
                }
            }
            &>div:last-child{
                margin:5px 0;
            }
        }
        .showreadall{
            text-align: center;
            cursor: pointer;
        }
    }

    .third-platform-shares {
        height: 36px;
        padding-left: 2px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        opacity: 0;

        img {
            width: 28px;
            height: 28px;
            margin-right: 7px;
            border-radius: 50%;
        }
    }

    .qrcode-catelog-mask {
        width: 270px;
    }

    .info-qcode-mask {
        width: 270px;
        box-sizing: border-box;
        padding: 30px 15px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .cover {
            display: block;
            width: 240px;
            height: 304px;
            border-radius: 4px;
            background: #f6f6f6;
        }

        h5 {
            
            font-size: 20px;
            color: #1A1A1A;
            line-height: 20px;
            margin: 24px 0 8px;
        }

        span {
            
            font-size: 14px;
            color: #8590A6;
            line-height: 14px;
        }

        .qrcode {
            display: block;
            width: 132px;
            height: 132px;
            margin-top: 24px;
            background: #f6f6f6;
        }
        .qrcode>img{
            width: inherit;
            height:inherit;
        }
        .qrocdenologin{
            border: 1px solid #e9e9e9;
        }
    }

    .catelog-mask {
        width: 270px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        margin-top: 20px;
        //position:sticky;
        //top: 0px;
        z-index: 9;
        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            padding-left: 16px;
            border-bottom: 1px solid #F0F2F7;
        }
    }

    .catelog-body-wrapper {
        width: 100%;
        height: fit-content;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .catelog-body {
        width: 100%;
        box-sizing: border-box;
        padding: 8px 0;
    }

    .catelog-item {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        padding: 0 16px;
        
        font-size: 14px;
        color: #1A1A1A;
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }

    .catelog-item:hover {
        background: #F6F6F6;
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: none;
    }

    .loader {
        width: 100%;
        height: 370px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>

<style>
    .article-content-bindDom * {
        max-width: 702px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-indent: 0 !important;
        font-size: 18px !important;
        color: #363636 !important;
        letter-spacing: 0 !important;
        text-align: justify !important;
        line-height: 32px !important;
        user-select:text !important;
    }

    .article-content-bindDom p {
        text-indent: 2em !important;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .article-content-bindDom h1,
    .article-content-bindDom h2,
    .article-content-bindDom h3,
    .article-content-bindDom h4,
    .article-content-bindDom h5 {
        font-size: 22px !important;
        color: #1E1E1E !important;
        letter-spacing: 0 !important;
        text-align: center !important;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .article-content-bindDom p img {
        margin-left: -2em !important;
    }

    .article-content-bindDom img {
        display: inline-block !important;
    }

    .bscroll-vertical-scrollbar {
        z-index: 9 !important;
    }
</style>
